<script setup>
import { ChevronLeft, ChevronRight } from "lucide-vue-next";
import { computed } from "vue";

const props = defineProps({
  currentPage: { type: Number, required: true },
  perPage: { type: Number, required: true },
  totalItems: { Number, required: true },
  loading: Boolean,
});

const emit = defineEmits(["page-change"]);

const totalPages = computed(() => Math.ceil(props.totalItems / props.perPage));

const handlePageChange = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    emit("page-change", page);
  }
};

const startIndex = computed(() => (props.currentPage - 1) * props.perPage + 1);
const endIndex = computed(() =>
  Math.min(props.currentPage * props.perPage, props.totalItems)
);
</script>

<template>
  <nav
    v-if="totalItems > 0 && loading == false"
    class="flex flex-col md:flex-row items-center justify-between pt-4 px-3 py-1 bg-white"
  >
    <span class="text-[15px] font-bold text-gray-400 mb-2 md:mb-0">
      Mostrando {{ startIndex }} - {{ endIndex }} de {{ totalItems }} dados
    </span>
    <div class="flex items-center space-x-0">
      <button
        @click="handlePageChange(props.currentPage - 1)"
        :disabled="props.currentPage === 1"
        class="px-1 py-1 text-sm font-medium text-gray-700 bg-white shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed"
        arial-label="Página anterior"
      >
        <ChevronLeft size="22" class="text-orange-600" />
      </button>

      <!-- Paginas -->

      <div class="flex gap-2">
        <button
          v-for="page in totalPages"
          :key="page"
          @click="handlePageChange(page)"
          class="px-3 py-1 text-sm"
          :class="
            props.currentPage === page
              ? 'bg-orange-600 text-white'
              : 'bg-gray-300 text-gray-700 border-gray-300 hover:bg-gray-100'
          "
        >
          {{ page }}
        </button>
      </div>
      <!-- Botao Proximo -->
      <button
        @click="handlePageChange(props.currentPage + 1)"
        :disabled="props.currentPage === totalPages"
        class="px-1 py-1 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed"
        arial-label="Próxima página"
      >
        <ChevronRight size="22" class="text-orange-500" />
      </button>
    </div>
  </nav>
</template>